const translations = {
    TEXT: {
        alreadyPurchase: "You already refund points.\nPlease check in my wallet.",
        eventPointZero: "You have no refund point\nPlease participate\n" + "in the next time",
    },

    MODAL: {
        loginModalTitle: "Login required",
        loginModalContent: (
            <div>
                <p>
                    Would you like to
                    <br />
                    go to login page?
                </p>
            </div>
        ),

        noTargetModalTitle: "⚠️ Not eligible for the event",
        noTargetModalContent: (
            <div>
                <p>
                    For more details,
                    <br />
                    please inquire through
                    <br />
                    the Q&A board
                </p>
            </div>
        ),

        afterRegistedTitle: (
            <div>
                <p>
                    🥹 Not eligible <br />
                    for the event
                </p>
            </div>
        ),
        afterRegistedContents: (
            <div>
                <p>
                    Unfortunately, this event is
                    <br />
                    only for members
                    <br />
                    who joined before 23/06/24
                </p>
            </div>
        ),

        applyModalTitle: (
            <div>
                <p>
                    Would you like to
                    <br />
                    refund points?
                </p>
            </div>
        ),
        applyModalContent: (
            <div>
                <p>
                    Refund points will be
                    <br />
                    paid automatically
                </p>
            </div>
        ),

        checkDoneTitle: `Refund points completed`,
        checkDoneContent: (
            <div>
                <p>
                    Please check refunded
                    <br />
                    like points in my wallet!
                </p>
            </div>
        ),

        duplecatedApplyModalTitle: "You already refund points.",
        duplecatedApplyModalContent: <div>Please check in my wallet.</div>,

        innerModalTitle: "Not eligible for points! ",
        innerModalContent: (
            <div>
                <p>
                    Employees are not
                    <br />
                    eligible for points
                </p>
            </div>
        ),

        noPointModalTitle: "You have no refund point",
        noPointModalContent: (
            <div>
                Please participate
                <br />
                in the next time
            </div>
        ),

        successModalTitle: "-",
        successModalContent: (
            <div>
                <p>좋아요 환급 포인트는</p>
                <p>내 지갑에서 확인해주세요!</p>
            </div>
        ),
    },
    BUTTON: {
        ok: "OK",
        refund: "Sure",
        login: "Going to Log-in",
        qna: "Inquire",
    },
    TRACKING_CODE: {
        view: "web_event_start",
        calculate: "calcul_total_like",
        refund: "receive_total_point",
    },
}

export default translations
